import store from "../../../store";

export default function filterArea(searchText, maxResults) {
  const storeState = store.getState();
  const options = storeState.services.codebook.areas;

  let counter = 0;
  let returnArray = [];

  for (let option of options) {
    if (counter >= maxResults) {
      break;
    }

    if (option.l.includes(searchText.replace(/[^A-Za-z]/g, "").toLowerCase())) {
      returnArray.push({
        v: option.v,
        a: option.a,
        c: option.c,
        lat: option.lat,
        lng: option.lng,
        latitude: option.latitude,
        longitude: option.longitude,
        gps_lat: option.gps_lat,
        gps_lng: option.gps_lng
      });
      counter++;
    }
  }

  if (returnArray.length === 0) {
    returnArray.push({ v: 0, l: "", a: "No result found", c: "" });
  }

  return returnArray;
}
